module.exports = __webpack_public_path__ + "img/logo-rsr.59b30b12.jpg";